import { render } from "./InputIconWrapper.vue?vue&type=template&id=4d8e7d14"
const script = {}

import exportComponent from "E:\\WorkingDirectory\\zarinmenuadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__